/**
 * Preprocess keys to filter out unwanted keys
 * @param {String[]} keys ['sale', 'sale.invoice', 'sale.invoice.modifiers', 'sale.modifiers']
 * @param {Boolean} hideModifiers - - will hide eg: sale.invoice.modifiers / sale.modifiers
 * @param {Boolean} hideSubmoduleKeys - will hide eg: sale.invoice
 * @param {Boolean} hideSubmoduleModifiers - will hide eg: sale.invoice.modifiers
 * @returns
 */
export function filterKeys(keys, hideModifiers, hideSubmoduleKeys = false, hideSubmoduleModifiers = false) {
    const filteredKeys = keys.filter(key => {
        const isModifier = key.includes('modifiers');
        const isSubmodule = key.includes('.') && !isModifier;
        const isSubmoduleModifier = key.split('.').length > 2 && isModifier;
        if (hideModifiers && isModifier)
            return false;
        if (hideSubmoduleKeys && isSubmodule)
            return false;
        if (hideSubmoduleModifiers && isSubmoduleModifier)
            return false;
        return true;
    });
    // console.log('aaa filterKeys', {keys, filteredKeys, hideSubmoduleKeys});

    return filteredKeys;
}
